<template>
  <div class="PatientManager">
    <div class="toolBar">
      <!-- <div class="nameGroup">
        <Input v-model="search.blendSpecimenBarcode" placeholder="请输入混检条形码" style="width: 150px" clearable/>
      </div> -->
      <div class="nameGroup">
        <Input
          v-model="barCode"
          placeholder="请输入标本条码"
          style="width: 150px"
        />
      </div>
      <div class="nameGroup">
        <Input
          v-model="patientName"
          placeholder="请输入患者姓名"
          style="width: 150px"
        />
      </div>
      <div class="nameGroup">
        <Input
          v-model="phoneNo"
          placeholder="请输入手机号"
          style="width: 150px"
        />
      </div>
      <div class="nameGroup">
        <DatePicker
          type="daterange"
          v-model="createTime"
          split-panels
          placeholder="创建时间"
          style="width: 150px"
          @on-change="dateTimeChange"
        ></DatePicker>
      </div>
      <div class="nameGroup">
        <DatePicker
          type="datetimerange"
          v-model="createTime2"
          split-panels
          placeholder="采样时间"
          style="width: 280px"
          @on-change="dateTimeChange2"
        ></DatePicker>
      </div>
      <div class="nameGroup">
        <Select
          v-model="state"
          style="width: 150px"
          filterable
          placeholder="选择状态"
        >
          <Option
            v-for="item in stateList"
            :value="item.code"
            :key="item.code"
            >{{ item.name }}</Option
          >
        </Select>
      </div>
      <div class="nameGroup">
        <Select
          v-model="type"
          style="width: 150px"
          filterable
          placeholder="选择检验类型"
        >
          <Option
            v-for="item in typeList"
            :value="item.code"
            :key="item.code"
            >{{ item.name }}</Option
          >
        </Select>
      </div>
      <Button
        type="primary"
        custom-icon="iconfont iconsousuo1"
        style="height: 32px; margin: 4px"
        @click="loadList"
        >搜索</Button
      >
      <Button
        type="primary"
        custom-icon="iconfont iconshuaxin"
        style="height: 32px; margin: 4px"
        @click="reset"
        ghost
        >重置</Button
      >
      <!-- <Button
        type="primary"
        custom-icon="iconfont iconsousuo1"
        style="height: 32px; margin: 4px"
        @click="createQR"
        >生成二维码</Button
      > -->
          <Button
        type="primary"
        custom-icon="iconfont iconsousuo1"
        style="height: 32px; margin: 4px"
        @click="createQR1(1)"
        >导出数据</Button
      >
       <Button type="primary" @click="createQR1(2)" style="height:32px;margin:4px;">导出(卫健委格式)</Button>
    </div>
    <div class="mainBox">
      <Table
        :height="tableHeight"
        ref="table"
        v-show="!isVertical"
        :columns="columnsMain"
        :data="dataMain"
        class="vertical"
      ></Table>
      <div class="pageBox">
        <Page
          :total="total"
          :current="pageCurrent"
          :transfer="true"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="changePageSize"
        />
      </div>
    </div>
    <!-- :name="modelName" -->
    <Modal
      class="qrModal"
      v-model="modal1"
      :title="modelTitle"
      width="400"
      @on-ok="ok"
      @on-cancel="cancel"
    >
      <p style="height: 300px; text-align: center">
        <img
          v-if="imgSrc"
          style="width: 300px; height: 300px"
          :src="imgSrc"
          alt=""
        />
        <span v-else>暂无二维码！</span>
      </p>
    </Modal>
    <!-- 订单详情 -->
    <Modal
      v-model="modal"
      title="查看详情"
      width="1000"
      @on-visible-change="detailClose"
      :loading="loading"
      :mask-closable="false"
      footer-hide
    >
      <p slot="header" style="text-align: left; color: #fff">
        <span>订单详情</span>
      </p>
      <div class="basiModal">
        <div class="modalBox">
          <div class="modTitle">基本信息</div>
          <div class="modContent">
            <ul>
              <li>
                <p>
                  订单号：<span>{{ orderDetailList.orderCode }}</span>
                </p>
                <p>
                  下单时间：<span>{{
                    orderDetailList.submitTime | replaceT
                  }}</span>
                </p>
                <p>
                  采样时间：<span>{{
                    orderDetailList.samplingTime | replaceT
                  }}</span>
                </p>
                <p>
                  业务员：<span>{{ orderDetailList.saleName }}</span>
                </p>
              </li>
              <li>
                <p>
                  录单人：<span>{{ orderDetailList.luDanName }}</span>
                </p>
                <p class="special">
                  备注：<span>{{ orderDetailList.remark }}</span>
                </p>
              </li>
              <li class="line1">
                <p class="special2">
                  送检医院：<span>{{ orderDetailList.hospitalName }}</span>
                </p>
              </li>
              <li>
                <p>
                  送检医生：<span>{{ orderDetailList.doctorName }}</span>
                </p>
                <p>
                  患者姓名：<span>{{ orderDetailList.patName }}</span>
                </p>
                <p>
                  患者性别：<span>{{
                    (orderDetailList.patSex + "") | dictionaryValue(sexList)
                  }}</span>
                </p>
                <p>
                  患者年龄：<span>{{ orderDetailList.patAge }}</span>
                </p>
              </li>
              <li>
                <p>
                  患者生日：<span>{{ orderDetailList.birthday }}</span>
                </p>
                <p>
                  身份证号：<span>{{ orderDetailList.idNumber }}</span>
                </p>
                <p>
                  民族：<span>{{ orderDetailList.nation }}</span>
                </p>
                <p>
                  患者电话：<span>{{ orderDetailList.patPhone }}</span>
                </p>
              </li>
              <li>
                <p>
                  身高：<span>{{ orderDetailList.bodyHeight }}</span>
                </p>
                <p>
                  体重：<span>{{ orderDetailList.bodyWeight }}</span>
                </p>
                <p>
                  住院病区/科室：<span>{{
                    orderDetailList.inpatientWardNo
                  }}</span>
                </p>
                <p>
                  床号：<span>{{ orderDetailList.bedNo }}</span>
                </p>
              </li>
              <!-- <li>
                  <p>患者登记号,门诊号/住院号：<span>{{orderDetailList.patientRegisterNo}}</span></p>
                </li> -->
              <li>
                <p>
                  详细地址：<span>{{ orderDetailList.address }}</span>
                </p>
              </li>
            </ul>
          </div>
          <Table border :columns="columns1" :data="data1"></Table>
          <div class="modalBox">
            <div class="modTitle">申请单</div>
            <div class="modContent">
              <div class="imgBox">
                <viewer :images="applyImgs">
                  <span v-for="(img, index) in applyImgs" :key="index">
                    <img :src="img" alt="" />
                  </span>
                </viewer>
                <span v-if="!applyImgs.length > 0">暂无申请单</span>
              </div>
            </div>
          </div>
          <div class="modalBox">
            <div class="modTitle">报告单</div>
            <div class="modContent">
              <div class="imgBox">
                <viewer :images="reportImgs">
                  <span v-for="(img, index) in reportImgs" :key="index">
                    <img :src="img" alt="" />
                  </span>
                </viewer>
                <span v-if="!reportImgs.length > 0">暂无报告单</span>
              </div>
            </div>
          </div>
        </div>
        <div class="modalBox">
          <div class="modTitle">加做信息</div>
          <Table border :columns="columnsJoin" :data="dataJoin"></Table>
        </div>
        <div class="modalBox">
          <div class="modTitle">退单信息</div>
          <Table border :columns="columnsReturn" :data="dataReturn"></Table>
        </div>
        <div class="modalBox">
          <div class="modTitle">财务信息</div>
          <div class="modContent">
            <ul>
              <li class="line1">
                <p>
                  支付状态：<span>{{ orderDetailList.payState }}</span>
                </p>
                <p>
                  支付时间：<span>{{ orderDetailList.payTime }}</span>
                </p>
                <p>
                  支付方式：<span>{{ orderDetailList.payType }}</span>
                </p>
                <p>
                  应收金额：<span>{{ orderDetailList.settleAmount }}</span>
                </p>
              </li>
              <li>
                <p>
                  实收金额：<span>{{ orderDetailList.actualAmount }}</span>
                </p>
                <p class="special">
                  支付流水号：<span>{{ orderDetailList.transactionId }}</span>
                </p>
              </li>
            </ul>
          </div>
        </div>
        <div class="modalBox">
          <div class="modTitle">检验中心日志</div>
          <Table border :columns="columns2" :data="data2"></Table>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  delPatient,
  patientDetail,
  patientList,
  savePatient,
  getEmployeePage,
  getDetail,
  qrCodeBase64,
  delNCP,
  xgOrder
} from "../../api/patient";
import {
  provinceList,
  nextList,
  selectDictDataListByDictCode,
} from "./../../api/common.js";
import {
  tips,
  replaceT,
  payType,
  dictionaryValue,
  formatDate,
} from "../../tools";
import { baseUrl } from "./../../config/index";
export default {
  name: "PatientManager",
  data() {
    return {
      barCode: null,
      baseUrl:baseUrl,
      patientName: null,
      phoneNo: null,
      beginTime: null,
      endTime2: null,
      beginTime2: null,
      endTime: null,
      createTime: [null, null],
      createTime2: [null, null],
      state: null,
      typeList:[{name:"单检",code:1},{name:"混检",code:2}],
      type:"",
      stateList: [
        {
          name: "待采样",
          code: 1,
        },
        {
          name: "已采样",
          code: 2,
        },
        {
          name: "检验中",
          code: 3,
        },
        {
          name: "已出报告",
          code: 4,
        },
         {
          name: "待同步订单",
          code: 99,
        },
      ],
      columns1: [
        { title: "检验条码", key: "barcode" },
        { title: "客户标本条码", key: "customerSpecimenBarcode" },
        { title: "检验项目名称", key: "projectName", minWidth: 120 },
        { title: "标本类型", key: "specimenType" },
        { title: "采集容器", key: "containerType" },
      ],
      data1: [],
      columns2: [
        { title: "检验条码", key: "specimenBarcode" },
        { title: "日志类型", key: "type" },
        { title: "交互时间", key: "createTime" },
        { title: "结果", key: "result" },
        { title: "备注", key: "remark" },
      ],
      data2: [],
      columnsJoin: [
        {
          title: "申请时间",
          key: "applyTime",
          render: (h, params) => {
            return h("div", [h("span", replaceT(params.row.applyTime))]);
          },
        },
        { title: "检验条码", key: "barcode" },
        { title: "采集容器", key: "containerType" },
        { title: "检验项目名称", key: "projectName" },
      ],
      dataJoin: [],
      columnsReturn: [
        {
          title: "申请时间",
          key: "applyTime",
          render: (h, params) => {
            return h("div", [h("span", replaceT(params.row.applyTime))]);
          },
        },
        { title: "检验条码", key: "barcode" },
        { title: "采集容器", key: "containerType" },
        { title: "检验项目名称", key: "projectName" },
      ],
      dataReturn: [],
      reportImgs: [],
      applyImgs: [],
      sexList: [],
      loading: false,
      modal: false,
      //禁用今天之后的日期
      options3: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        },
      },
      tableHeight: 632,
      delId: 0, //删除id
      // modelName:'delModal',
      modal1: false,
      modelTitle: "系统提示",
      modeIcon: " iconfont icon-Group-",
      iconColor: "#2778E7",
      modelContent: "",
      manIcon: require("../../assets/img/man.png"),
      womenIcon: require("../../assets/img/women.png"),
      total: 0,
      pageCurrent: 1,
      pageSize: 10,
      name: "", //患者姓名/手机号
      doctor: "", //医生
      startDate: "",
      endDate: "",
      columnsMain: [
        //  {
        //       title: '混检条形码',
        //       key: 'blendSpecimenBarcode',
        //       align: 'center',
        //       width:120,
        //   },
        {
          title: "条码",
          width: 120,
          key: "specimenBarcode",
          align: "center",
          render: (h, params) => {
            return h("div", {
              style: {
                textAlign: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title: params.row.specimenBarcode
                  ? params.row.specimenBarcode
                  : "",
                innerHTML: params.row.specimenBarcode
                  ? params.row.specimenBarcode
                  : "",
              },
            });
          },
        },
         {
              title: '检验类型',
              key: 'type',
              align: 'center',
              minWidth:120,
              render:(h,params) => {
                return h('div', [
                  h('span', params.row.type?params.row.type==1?"单检":params.row.type==2?"混检":"":"")
                ])
              }
          },
        {
          title: "患者姓名",
          width: 70,
          key: "name",
          align: "center",
          render: (h, params) => {
            return h("div", {
              style: {
                textAlign: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title: params.row.name ? params.row.name : "",
                innerHTML: params.row.name ? params.row.name : "",
              },
            });
          },
        },
        {
          width: 40,
          title: "性别",
          key: "sex",
          align: "center",
          render: (h, params) => {
            return h("div", {
              style: {
                textAlign: "center",
              },
              domProps: {
                innerHTML: params.row.sex == 1 ? "女" : "男",
              },
            });
          },
        },
        {
          width: 50,
          title: "年龄",
          key: "age",
          align: "center",
          render: (h, params) => {
            return h("div", {
              style: {
                textAlign: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title: params.row.age
                  ? params.row.age
                  : "" + params.row.ageUnit
                  ? params.row.ageUnit
                  : "",
                innerHTML: params.row.age
                  ? params.row.age
                  : "" + params.row.ageUnit
                  ? params.row.ageUnit
                  : "",
              },
            });
          },
        },
        {
          width: 50,
          title: "身高",
          key: "height",
          align: "center",
          render: (h, params) => {
            return h("div", {
              style: {
                textAlign: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title: params.row.height ? params.row.height : "",
                innerHTML: params.row.height ? params.row.height : "",
              },
            });
          },
        },
        {
          width: 50,
          title: "体重",
          key: "weight",
          align: "center",
          render: (h, params) => {
            return h("div", {
              style: {
                textAlign: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title: params.row.weight ? params.row.weight : "",
                innerHTML: params.row.weight ? params.row.weight : "",
              },
            });
          },
        },
        {
          title: "手机号",
          width: 90,
          key: "mobile",
          align: "center",
          render: (h, params) => {
            return h("div", {
              style: {
                textAlign: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title: params.row.mobile ? params.row.mobile : "",
                innerHTML: params.row.mobile ? params.row.mobile : "",
              },
            });
          },
        },
        {
              title: '证件类型',
              key: 'idType',
              align: 'center',
              minWidth: 130,
              render: (h,params) => {
                let list =[
                  {code:"1",name:"居民身份证"},
                  {code:"2",name:"护照"},
                  {code:"3",name:"港澳居民来往内地通行证（俗称回乡证）"},
                  {code:"4",name:"台湾居民来往内地通行证（俗称台胞证）"},
                  {code:"5",name:"出生医学证明"},
                  {code:"99",name:"其他"},
                  ]
                for(let i=0;i<list.length;i++){
                  if(params.row.idType==list[i].code){
                    return h('span',list[i].name)
                  }
                }
              }
          },
        {
          title: "身份证",
          minWidth: 135,
          key: "idNumber",
          align: "center",
          render: (h, params) => {
            return h("div", {
              style: {
                textAlign: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title: params.row.idNumber ? params.row.idNumber : "",
                innerHTML: params.row.idNumber ? params.row.idNumber : "",
              },
            });
          },
        },
         {
              title: '国家/地区',
              key: 'country',
              align: 'center',
              minWidth: 100,
          },
        // {
        //     title: '省',
        //     key: 'provinceName',
        //     align:'center',
        //     render:(h,params) => {
        //       return h('div',{
        //         style: {
        //           textAlign: 'center',
        //           overflow: 'hidden',
        //           textOverflow: 'ellipsis',
        //           whiteSpace: 'nowrap'
        //         },
        //         domProps: {
        //           title:params.row.provinceName,
        //           innerHTML: params.row.provinceName
        //         },
        //       })
        //     }
        // },
        // {
        //     title: '市',
        //     key: 'cityName',
        //     align:'center',
        //     render:(h,params) => {
        //     return h('div',{
        //       style: {
        //         textAlign: 'center',
        //         overflow: 'hidden',
        //         textOverflow: 'ellipsis',
        //         whiteSpace: 'nowrap'
        //       },
        //       domProps: {
        //         title:params.row.cityName,
        //         innerHTML: params.row.cityName
        //       },
        //     })
        //   }
        // },
        // {
        //     title: '区',
        //     key: 'areaName',
        //     align:'center',
        //     render:(h,params) => {
        //       return h('div',{
        //         style: {
        //           textAlign: 'center',
        //           overflow: 'hidden',
        //           textOverflow: 'ellipsis',
        //           whiteSpace: 'nowrap'
        //         },
        //         domProps: {
        //           title:params.row.provinceName+' '+cityName+' '+params.row.areaName+' ',
        //           innerHTML: params.row.areaName
        //         },
        //       })
        //     }
        // },
        {
          title: "详细地址",
          key: "address",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            let provice = params.row.provinceName
              ? params.row.provinceName
              : "";
            let city = params.row.cityName ? params.row.cityName : "";
            let area = params.row.areaName ? params.row.areaName : "";
            let address = params.row.address ? params.row.address : "";
            let addressDetail =
              provice + " " + city + " " + area + " " + address;
            return h("div", {
              style: {
                textAlign: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title: addressDetail,
                innerHTML: addressDetail,
              },
            });
          },
        },
        {
          title: "是否接触过新冠人员",
          key: "contactedCovidPersonFlag",
          align: "center",
          width: 50,
          render: (h, params) => {
            return h("div", {
              style: {
                textAlign: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  params.row.contactedCovidPersonFlag == 1
                    ? "是"
                    : params.row.contactedCovidPersonFlag == 0
                    ? "否"
                    : "",
                innerHTML:
                  params.row.contactedCovidPersonFlag == 1
                    ? "是"
                    : params.row.contactedCovidPersonFlag == 0
                    ? "否"
                    : "",
              },
            });
          },
        },
        {
          title: "是否接触过疫区人员",
          width: 50,
          key: "contactedEpidemicAreaFlag",
          align: "center",
          render: (h, params) => {
            return h("div", {
              style: {
                textAlign: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  params.row.contactedEpidemicAreaFlag == 1
                    ? "是"
                    : params.row.contactedEpidemicAreaFlag == 0
                    ? "否"
                    : "",
                innerHTML:
                  params.row.contactedEpidemicAreaFlag == 1
                    ? "是"
                    : params.row.contactedEpidemicAreaFlag == 0
                    ? "否"
                    : "",
              },
            });
          },
        },
        {
          title: "健康状态",
          minWidth: 80,
          key: "healthFlag",
          align: "center",
          render: (h, params) => {
            return h("div", {
              style: {
                textAlign: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                color: params.row.healthFlag == 1 ? "#3985BE" : "red",
              },
              domProps: {
                title:
                  params.row.healthFlag == 1
                    ? "健康"
                    : params.row.healthFlag == 2
                    ? "发烧咳嗽等症状"
                    : params.row.healthFlag == 3
                    ? "其他症状"
                    : "",
                innerHTML:
                  params.row.healthFlag == 1
                    ? "健康"
                    : params.row.healthFlag == 2
                    ? "发烧咳嗽等症状"
                    : params.row.healthFlag == 3
                    ? "其他症状"
                    : "",
              },
            });
          },
        },
        {
          title: "备注",
          minWidth: 60,
          key: "remark",
          align: "center",
          render: (h, params) => {
            return h("div", {
              style: {
                textAlign: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title: params.row.remark ? params.row.remark : "",
                innerHTML: params.row.remark ? params.row.remark : "",
              },
            });
          },
        },
        {
          title: "创建时间",
          width: 130,
          key: "createTime",
          align: "center",
          render: (h, params) => {
            return h("div", {
              style: {
                textAlign: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title: replaceT(
                  params.row.createTime ? params.row.createTime : ""
                ),
                innerHTML: replaceT(
                  params.row.createTime ? params.row.createTime : ""
                ),
              },
            });
          },
        },
         {
          title: "采样时间",
          width: 130,
          key: "writeOffTime",
          align: "center",
          render: (h, params) => {
            return h("div", {
              style: {
                textAlign: "center",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title: replaceT(
                  params.row.writeOffTime ? params.row.writeOffTime : ""
                ),
                innerHTML: replaceT(
                  params.row.writeOffTime ? params.row.writeOffTime : ""
                ),
              },
            });
          },
        },
        {
          title: "状态",
          minWidth: 110,
          key: "status",
          align: "center",
          render: (h, params) => {
            let statusName = "";
            switch (params.row.status) {
              case 1:
                statusName = "待采样";
                break;
              case 2:
                statusName = "已采样";
                break;
              case 3:
                statusName = "检验中";
                break;
              case 4:
                statusName = "已出报告";
                break;
              case 99:
                statusName = "待同步订单";
                break;
            }
            return h(
              "div",
              {
                style: {
                  textAlign: "center",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                },
                domProps: {
                  title: statusName,
                  //     innerHTML:statusName
                },
              },
              [
                h("span", {
                  style: {
                    color: "#559DF9",
                    display: "inline-block",
                    textAlign: "center",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  },
                  domProps: {
                    // 添加标签,使用自己引入的iconfont图标
                    title: statusName,
                    innerHTML:
                      "<i class='iconfont icon-shixinyuanxing'></i>" +
                      statusName,
                  },
                }),
              ]
            );
          },
        },
        {
          title: "操作",
          align: "center",
          key: "methods",
          width: 210,
          fixed:"right",
          render: (h, params) => {
            return h(
              "div",
              {
                style: {
                  textAlign: "center",
                },
              },
              [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small",
                      ghost: true,
                      disabled: params.row.status > 1 ? false : true,
                    },
                    style: {
                      marginRight: "5px",
                      // color: params.row.status == 1 ? "#3985BE" : "#eee",
                    },
                    on: {
                      click: () => {
                        let id = params.row.orderId;
                        console.log(id);

                        this.getOrderDetail(id);
                      },
                    },
                  },
                  "订单详情"
                ),
                 h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small",
                      ghost: true,
                    },
                    style: {
                      marginRight: "5px",
                      display:params.row.status==99?'inline-block':'none'
                    },
                    on: {
                      click: () => {
                        let id = params.row.id;
                        this.getSam(id);
                      },
                    },
                  },
                  "同步订单"
                ),
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small",
                      ghost: true,
                    },
                    style: {
                      marginRight: "5px",
                    },
                    on: {
                      click: () => {
                        let id = params.row.id;
                        this.getDel(id);
                      },
                    },
                  },
                  "删除"
                ),
              ]
            );
          },
        },
      ],
      dataMain: [],
      isVertical: false, //是否为横版
      verticalName: "横版",
      verticalIcon: "iconfont icon-zhanshi",
      orderDetailList: [], //订单详情
      imgSrc: "",
    };
  },
  created() {
    let lett = this;
    document.onkeydown = function (e) {
      let key = window.event.keyCode;
      if (key == 13) {
        lett.search();
      }
    };
  },
  mounted() {
    console.log
    window.addEventListener("resize", this.getTableHeight(90));
    // this.getTableHeight(60);
    console.log(this.tableHeight);
    this.loadList();
    this.getSex();
  },
  filters: {
    healthFlag(val) {
      switch (val) {
        case 1:
          return "健康";
          break;
        case 2:
          return "发烧咳嗽等症状";
          break;
        case 3:
          return "其他症状";
      }
    },
    replaceT,
    dictionaryValue,
  },
  methods: {
    getSam(id){
      let _this = this;
         _this.$Modal.confirm({
          title: "同步订单",
          content: "<p>确认同步这条记录吗？</p>",
          okText: "确定",
          cancelText: "取消",
          onOk: () => {
            xgOrder({
                 ids:id
              }).then(res=>{
                if(res.code==0){
                  tips(this,res.data,'success');
                  this.search();
                }else{
                  tips(this,res.data,'warning');
                }
            });
          },
          onCancel: () => {}
        });
    },
    getDel(id){
      let _this = this;
        console.log(id)
         _this.$Modal.confirm({
          title: "删除",
          content: "<p>确认删除这条记录吗？</p>",
          okText: "确定",
          cancelText: "取消",
          onOk: () => {
            delNCP({
                 id
              }).then(res=>{
                if(res.code==0){
                  tips(this,res.msg,'success');
                  this.search();
                }else{
                  tips(this,res.msg,'warning');
                }
            });
          },
          onCancel: () => {}
        });
    },
    getTableHeight(len) {
      // 设置表格高度
      this.tableHeight =
        window.innerHeight - this.$refs.table.$el.offsetTop - len;
    },
    loadList() {
      this.pageCurrent = 1;
      this.search();
    },
    getOrderDetail(id) {
      let _this = this;
      getDetail({
        id: id,
      }).then((res) => {
        if (res.code == 0) {
          _this.modal = true;
          console.log(res);
          let temp = res.data;
          _this.orderDetailList = temp;
          for (let i of temp.orderProjectLabs) {
            i.payTime = i.payTime ? formatDate(i.payTime, "01", "03") : "";
          }
          _this.data1 = temp.orderProjectLabs;
          for (let i of temp.logList) {
            i.createTime = i.createTime
              ? formatDate(i.createTime, "01", "03")
              : "";
          }
          _this.data2 = temp.logList;
          if (temp.appleForms) {
            let licenceImg = [];
            for (let i = 0; i < temp.appleForms.length; i++) {
              let attachId = temp.appleForms[i];
              let fileName = "申请单" + i;
              let url =
                baseUrl +
                `common/common/downLoadFile?attachId=${attachId}&fileName=${fileName}&type=2`;
              licenceImg.push(url);
            }
            _this.applyImgs = licenceImg;
          }

          if (temp.reportForms) {
            let reportImg = [];
            // let imgArr = reportImgId.split(',');
            for (let i = 0; i < temp.reportForms.length; i++) {
              let attachId = temp.reportForms[i];
              let fileName = "报告单" + i;
              let url =
                baseUrl +
                `common/common/downLoadFile?attachId=${attachId}&fileName=${fileName}&type=2`;
              reportImg.push(url);
            }
            _this.reportImgs = reportImg;
            // console.log(_this.reportImgs);
          }
          _this.dataJoin = temp.addInfo;
          _this.dataReturn = temp.refundInfo;
        } else {
          tips(_this, res.msg, "warning");
        }
      });
    },
    dateTimeChange(date) {
      // console.log(date);
      let _this = this;
      let startT = date[0];
      let endT = date[1];
      _this.beginTime = startT;
      _this.endTime = endT;
      // _this.beginTime = startT + ' 00:00:00';
      // _this.endTime = endT+ " 23:59:59";
    },
    dateTimeChange2(date) {
      // console.log(date);
      let _this = this;
      let startT = date[0];
      let endT = date[1];
      _this.beginTime2 = startT;
      _this.endTime2 = endT;
      // _this.beginTime = startT + ' 00:00:00';
      // _this.endTime = endT+ " 23:59:59";
    },
    reset() {
      this.barCode = null;
      this.patientName = null;
      this.phoneNo = null;
      this.beginTime = null;
      this.endTime = null;
      this.createTime = [null, null];
      this.beginTime2 = null;
      this.endTime2 = null;
      this.createTime2 = [null, null];
      this.state = null;
      this.pageCurrent = 1;
      this.search();
    },
    //性别
    getSex() {
      let _this = this;
      selectDictDataListByDictCode({
        typeCode: "sex",
      }).then((res) => {
        if (res.code == 0) {
          // console.log(res.data);
          _this.sexList = res.data;
        } else {
          tips(_this, res.msg, "warning");
        }
      });
    },
    detailClose(show) {
      if (!show) {
        this.hospitalName = "";
        this.doctorName = "";
        this.saleName = "";
        this.receiveName = "";
        this.patientName = "";
        this.sex = "";
        this.age = "";
        this.phone = "";
        this.applyImgs = [];
        this.reportImgs = [];
      }
    },
    createQR() {
      let _this = this;
      qrCodeBase64({}).then((res) => {
        _this.modal1 = true;
        _this.modelTitle = "扫码进入信息录入页";
        if (res.code == 0) {
          _this.imgSrc = "data:image/gif;base64," + res.data.base64;
        } else {
          tips("暂无二维码生成", "warning");
        }
      });
    },

        createQR1 (type) {
            if(!this.endTime2){
              this.endTime2=""
            }
            if(!this.beginTime2){
              this.beginTime2=""
            }
            let xhr = new XMLHttpRequest();
            let formData = new FormData();
            // formData.append('endDate',formatDate(this.endDate,'01','01'));
            let url = ''
            if(type==1){
              url=`${this.baseUrl}clinic-manager/covid/excelReport?current=${this.pageCurrent}&enabled=1&size=${this.pageSize}&samplingBeginTime=${this.beginTime2}&samplingEndTime=${this.endTime2}`
            }else{
              url=`${this.baseUrl}clinic-manager/covid/excelReportTemplate?current=${this.pageCurrent}&enabled=1&size=${this.pageSize}&samplingBeginTime=${this.beginTime2}&samplingEndTime=${this.endTime2}`
            }
            xhr.open('get', url, true);
            xhr.setRequestHeader("token", localStorage.getItem('his_token'));
            xhr.responseType = 'blob';
            xhr.onload = function (e) {
              if (this.status == 200) {
                let blob = this.response;
                let data = new Blob([blob],{type:"application/vnd.ms-excel"});
                let downloadUrl = window.URL.createObjectURL(data);
                let anchor = document.createElement("a");
                anchor.href = downloadUrl;
                // anchor.download = "医诺云检"+new Date().toLocaleTimeString()+".xls";
                anchor.download = "新冠检测登记"+new Date().toLocaleTimeString()+".xls";
                anchor.click();
                window.URL.revokeObjectURL(data)
              }
            };
            xhr.send(formData);
        },

    //搜索
    search() {
      let _this = this;
      let params = {
        current: _this.pageCurrent,
        size: _this.pageSize,
        // enabled: 1,
        mobile: _this.phoneNo,
        name: _this.patientName,
        specimenBarcode: _this.barCode,
        status: _this.state,
        beginTime: _this.beginTime,
        endTime: _this.endTime,
        samplingBeginTime:_this.beginTime2,
        samplingEndTime:_this.endTime2,
        type:this.type
      };
      getEmployeePage(params).then((res) => {
        console.log(res);
        _this.total = res.total;
        _this.dataMain = res.records;
        let arr = [];
        for (let i = 0; i < _this.dataMain.length; i++) {
          _this.dataMain[i].createTime = replaceT(_this.dataMain[i].createTime);
          _this.dataMain[i].diagnosisTime = replaceT(
            _this.dataMain[i].diagnosisTime
          );
        }
      });
    },
    //改变页码
    changePage(current) {
      console.log(current);
      this.pageCurrent = current;
      this.search();
    },
    //改变每页条数
    changePageSize(size) {
      this.pageSize = size;
      this.search();
    },
    ok() {
      let _this = this;
    },
    cancel() {
      console.log("取消！");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.PatientManager {
  height: 100%;
  overflow: scroll;
}
.PatientManager .toolBar {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap;
  /* padding: 19px; */
  /* padding: 10px 0; */
  /* border-bottom: 1px solid #c9c9c9; */
}
.nameGroup {
  margin-right: 14px;
  line-height: 40px;
}

.PatientManager .toolBar > p {
  padding: 5px 0;
  margin-right: 20px;
}
.PatientManager .toolBar > p /deep/ .ivu-input-wrapper {
  height: 32px;
}
.PatientManager .toolBar > p > label {
  display: inline-block;
}
.PatientManager .toolBar > p > button {
  margin-right: 20px;
}
.mainBox {
  margin-top: 10px;
}
.pageBox {
  text-align: center;
  padding: 5px 0;
  margin-top: 10px;
}
.ivu-input-wrapper {
  width: 120px;
}
.ivu-select {
  width: 120px;
  /* width: 100%; */
}
.ivu-date-picker {
  width: 120px;
}

.Horizontal {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-flow: row wrap;
}
.Horizontal /deep/ .ivu-card {
  width: 32%;
  margin: 0 10px 20px 0;
}
.Horizontal /deep/ .ivu-card-body {
  padding: 5px 0 0 0;
}
.Horizontal .ivu-card-body > div:first-child {
  height: 24px;
  padding: 0 10px;
}
.Horizontal .ivu-card-body > div:first-child > span {
  float: right;
  cursor: pointer;
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 50%;
  text-align: center;
  font-size: 16px;
}
.Horizontal .ivu-card-body > div:first-child > span:hover {
  color: #fff;
  background-color: #2778e7;
}
.Horizontal .mainCard {
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: 0 10px 10px;
}
.Horizontal .mainCard > .leftCard {
  width: 35%;
}
.Horizontal .mainCard > .leftCard > span:first-child {
  height: 70%;
  display: block;
  text-align: center;
}
.Horizontal .mainCard > .leftCard > span {
  display: inline-block;
  text-align: center;
  width: 100%;
}
.Horizontal .mainCard > .leftCard > span > img {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.Horizontal .mainCard > .rightCard {
  width: 64%;
}
.Horizontal .btnBox {
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #c9c9c9;
}
.Horizontal .btnBox > button {
  width: 50%;
  color: #2778e7;
}
.Horizontal .btnBox > .ivu-btn {
  border-radius: 0;
}
.Horizontal .btnBox > button:first-child {
  border-right: 1px solid #c9c9c9;
}
.ivu-card-bordered {
  border: 1px solid #c9c9c9;
}
/* 详情 */
.basiModal .modalBox {
  margin-bottom: 20px;
}
.basiModal .modalBox .modContent {
  border: 1px solid #e1e2e6;
}
.basiModal .modalBox .modContent > div.imgBox {
  padding: 2px;
}
.basiModal .modalBox .modContent > div.imgBox span {
  display: inline-block;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  margin-right: 10px;
  background-color: #dcdce6;
  position: relative;
  overflow: hidden;
}
.basiModal .modalBox .modContent > div.imgBox span > img {
  position: absolute;
  width: auto;
  height: auto;
  display: block;
  top: 50%;
  left: 50%;
  max-width: 100%;
  min-height: 100%;
  transform: translate(-50%, -50%);
}
.basiModal .modalBox .modContent > ul .line1 > span {
  width: 100%;
}
.basiModal .modalBox .modContent > ul .long {
  display: inline-block;
  background-color: #fff;
}
.basiModal .modalBox .modContent > ul .long p {
  color: #1e283f;
  font-weight: normal;
}
.basiModal .modalBox .modContent > ul .long p span {
  color: #5f6576;
}
.basiModal .modalBox .modContent > ul > li {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 12px;
  border-bottom: 1px solid #e1e2e6;
  background-color: #f8f8f9;
}
.basiModal .modalBox .modContent > ul > li:last-child {
  border: none;
}
.basiModal .modalBox .modContent ul > li > p {
  color: #1e283f;
  width: 25%;
  font-size: 14px;
}
.basiModal .modalBox .modContent ul > li > p.special {
  width: 74%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.basiModal .modalBox .modContent ul > li > p.special2 {
  width: 99%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.basiModal .modalBox .modContent ul > li > p > span {
  color: #5f6576;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/patient/Patient.vue